// Shared singleton loader for the Google Maps JavaScript API.
//
// Several pages/widgets (Add Geofence, the header's weather widget, etc.) each
// used to inject their own <script src="maps.googleapis.com/maps/api/js...">
// independently. Because the Header persists across client-side route
// navigation, more than one of these could end up loading the API at once,
// and whichever script finished loading last would redefine window.google.maps,
// invalidating Map/Marker/LatLng objects created against the earlier load
// ("not an instance of Map", "not a LatLng", "m.po is not a function").
//
// Callers should await loadGoogleMapsApi(key) instead of injecting their own
// script tag. The first caller starts the real load; everyone else reuses the
// same in-flight/resolved promise.
let loadingPromise = null;

export function loadGoogleMapsApi(apiKey) {
	if (window.google && window.google.maps && window.google.maps.places && window.google.maps.drawing) {
		return Promise.resolve();
	}
	if (loadingPromise) {
		return loadingPromise;
	}
	loadingPromise = new Promise((resolve) => {
		var callbackName = "__onGoogleMapsApiLoaded";
		window[callbackName] = () => {
			resolve();
		};
		var script = window.document.createElement("script");
		script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,drawing&v=3.64&callback=${callbackName}`;
		script.async = true;
		script.defer = true;
		var index = window.document.getElementsByTagName("script")[0];
		index.parentNode.insertBefore(script, index);
	});
	return loadingPromise;
}
